import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import I18n from 'PMT/i18n/I18n';

// -- constants
import ApiConstants from 'PMT/constants/ApiConstants';
import ViewConstants from 'constants/ViewConstants';

// -- entities
import Restaurant from 'PMT/entities/Restaurant';
import RestaurantMultipart from 'PMT/entities/RestaurantMultipart';

import { CurrencyUtils } from 'PMT/utils';
import SecurityContext from 'utils/permissions/SecurityContext';

// -- views
import RestaurantFormComponent from './RestaurantFormComponent';
import {
  POSChooser,
  ImageDropzone,
  TextInput,
  SimplePhoneInput,
  EmailInput,
  BitfieldChooser,
  NumberInput
} from 'PMT/components/form';
import Switch from 'react-bootstrap-switch';

export default class AdminFormView extends RestaurantFormComponent {

  static propTypes = {
    restaurant: PropTypes.objectOf(Restaurant),

    /**
    * @param RestaurantMultipart
    */
    onUpdate: PropTypes.func.isRequired
  };

  state = this.getDefaultState(this.props.restaurant);

  //
  // RestaurantFormComponent override.
  //

  getDefaultState(restaurant: Restaurant) {
    return {
      serviceType: restaurant.serviceType,

      features: restaurant.features,
    };
  }

  haveModifications() {
    const restaurant:Restaurant = this.props.restaurant;
    const state = this.state;

    return !(
      state.serviceType === restaurant.serviceType
      && state.features === restaurant.features
    );
  }

  //
  // form actions
  //

  onFeaturesChange = (features) => {
    this.setState({
      features
    });
  };

  onServiceTypeChange = (serviceType) => {
    this.setState({
      serviceType
    });
  };

  //
  // submit
  //

  onSubmit = (event) => {
    event.preventDefault();

    const restaurantMultipart: RestaurantMultipart = new RestaurantMultipart();

    restaurantMultipart.serviceType = this.state.serviceType;
    restaurantMultipart.features = this.state.features;

    this.props.onUpdate(restaurantMultipart);
  };

  //
  // renderers
  //

  renderServiceType() {
    const options = [
      {
        label: I18n.tr('restaurant_edit.features.table_number'),
        value: 1
      },
      {
        label: I18n.tr('restaurant_edit.features.qr_code'),
        value: 2
      },
      {
        label: I18n.tr('restaurant_edit.features.pairing'),
        value: 4
      }
    ];

    return (
      <div className="row form-group">
        <div className="col-xs-4 control-label">
          <label>
            {I18n.tr('restaurant_edit.features.retrieving_bill_method')}
          </label>
        </div>

        <div className="col-xs-6">
          <BitfieldChooser
            options={options}
            mask={this.state.serviceType}
            onChange={this.onServiceTypeChange}
            readOnly={!SecurityContext.restaurantSettings.editFeatures()}
          />
        </div>
      </div>
    );
  }

  renderFeatures() {
    const options = [
      {
        label: I18n.tr('restaurant_edit.features.payment'),
        value: 1
      },
      {
        label: I18n.tr('restaurant_edit.features.order'),
        value: 2
      },
    ];

    return (
      <div className="row form-group">
        <div className="col-xs-4 control-label">
          <label>
            {I18n.tr('restaurant_edit.features.label')}
          </label>
        </div>

        <div className="col-xs-6">
          <BitfieldChooser
            options={options}
            mask={this.state.features}
            onChange={this.onFeaturesChange}
            readOnly={!SecurityContext.restaurantSettings.editFeatures()}
          />
        </div>
      </div>
    );
  }

  render() {
    const restaurant: Restaurant = this.props.restaurant;

    return (
      <div className="edit_restaurant_form_view__private">
        <form className="form-horizontal">

          <div>
            {this.renderFeatures()}
            {this.renderServiceType()}
            {/* TODO: Order mode */}
            <hr />
          </div>

          {this.renderButtons()}
        </form>

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./scripts/pages/restaurant/edit/components/FeaturesFormView.js